// Outils (02/10) : le catalogue des outils proposes a l'installation (fenetre « Ajouter des
// outils » de la page Outils, outils a installer du selecteur de capacites, carte de mise en
// place d'un outil) est ferme par app. NEXT_PUBLIC_OUTILS (pose au build de la SPA,
// scripts/astraly/apps/<app>.env) liste les noms de serveurs admis, separes par des virgules.
// Vide ou absente : aucune restriction, comportement amont. Les serveurs deja installes ne sont
// pas concernes : la page Outils les liste toujours.
// NEXT_PUBLIC_OUTILS_MCP_PERSO=false masque le bouton « Ajouter un serveur MCP » (serveurs
// distants personnalises) ; absente ou toute autre valeur : bouton visible, comme l'amont.
// Lisible cote client : process.env.* est remplace au build.

/** Les noms de serveurs admis, ou null quand rien ne restreint (variable vide ou absente). */
export function outilsAdmis(
  brut: string | undefined = process.env.NEXT_PUBLIC_OUTILS
): ReadonlySet<string> | null {
  if (typeof brut !== "string") {
    return null;
  }
  const noms = brut
    .split(",")
    .map((n) => n.trim())
    .filter((n) => n.length > 0);
  return noms.length === 0 ? null : new Set(noms);
}

export function estOutilPropose(
  nom: string,
  brut: string | undefined = process.env.NEXT_PUBLIC_OUTILS
): boolean {
  const admis = outilsAdmis(brut);
  return admis === null || admis.has(nom);
}

/** La liste filtree ; la liste d'origine, telle quelle, quand rien ne restreint. */
export function filtrerOutilsProposes<T extends { name: string }>(
  serveurs: T[],
  brut: string | undefined = process.env.NEXT_PUBLIC_OUTILS
): T[] {
  const admis = outilsAdmis(brut);
  return admis === null ? serveurs : serveurs.filter((s) => admis.has(s.name));
}

export function mcpPersoVisible(
  brut: string | undefined = process.env.NEXT_PUBLIC_OUTILS_MCP_PERSO
): boolean {
  return typeof brut !== "string" || brut.trim().toLowerCase() !== "false";
}
